<main>
        <div class="notification" [style.background]="colors[notification.type]">
            <div class="content">
                <span class="material-symbols-outlined">
                    {{icons[notification.type]}}
                </span>
                <div class="message">
                    {{notification.message}}
                </div>
                
            </div>
            <div class="end">
    
            </div>
        </div>

</main>